import Container from './Container'

export default {
  Container
}



// WEBPACK FOOTER //
// ./src/centre/components/index.js